import * as React from "react";
import { createContext, useContext } from "react";
import { MfaMethod } from "@/services/bedrock/dtos";

export type Step = "SELECT_METHOD" | "ENTER_CODE" | "VERIFYING_PASSKEY" | "PROMPT_SETUP";

export interface MfaChallengeContextValue {
  step: Step;
  setStep: (step: Step) => void;
  method: MfaMethod | null;
  setMethod: (method: MfaMethod | null) => void;
  code: string;
  setCode: (code: string) => void;
  isLoading: boolean;
  setIsLoading: (loading: boolean) => void;
  error: string | null;
  setError: (error: string | null) => void;
  onOpenChange: (open: boolean) => void;
  onSuccess: () => void;
  onCancel: () => void;
}

export const MfaChallengeContext = createContext<MfaChallengeContextValue | undefined>(undefined);

export const useMfaChallengeContext = () => {
  const context = useContext(MfaChallengeContext);
  if (!context) {
    throw new Error("useMfaChallengeContext must be used within an MfaChallengeProvider");
  }
  return context;
};
